<h1 mat-dialog-title class="title">{{ data.title }}</h1>
<div mat-dialog-content class="description">
    <p>{{ data.description }}</p>
</div>
<div mat-dialog-actions align="end">
    <button style="opacity: 0"></button>
    <button mat-stroked-button (click)="onCancel()" id="cancel">Cancel</button>
    <button mat-button (click)="onLogout()" class="logout" id="logout">Log Out</button>
</div>
